// Direct import from Shakespeare AI image generation (available globally in this environment)
declare const generate_image: (params: {
  prompt: string;
  output_format?: 'png' | 'jpeg' | 'webp';
  output_compression?: number;
  size?: string;
  background?: string;
}) => Promise<string>;

export const generate_image = async (params: {
  prompt: string;
  output_format?: 'png' | 'jpeg' | 'webp';
  output_compression?: number;
  size?: string;
  background?: 'transparent' | 'opaque' | 'auto';
}): Promise<string> => {
  try {
    // Use the Shakespeare platform's built-in image generation tool
    if (typeof (window as any).generate_image === 'function') {
      const result = await (window as any).generate_image(params);
      if (typeof result === 'string' && result.length > 10) {
        return result;
      }
    }

    // Fallback for development / when tool is not available
    console.warn('Using placeholder image - configure image model in Settings > AI for real generation');
    return `https://picsum.photos/id/${100 + Math.floor(Math.random() * 900)}/800/600`;
  } catch (error) {
    console.error('Image generation failed:', error);
    return `https://picsum.photos/id/${100 + Math.floor(Math.random() * 900)}/800/600`;
  }
};
